import { createFileRoute, Navigate } from "@tanstack/react-router";
import { OrgFormsPage } from "@/features/org-forms/org-forms-page";
import { useOrganization } from "@/hooks/use-organization";
import { useOrgPath } from "@/hooks/useOrgPath";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/forms/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { selectedOrgBusinessUnit } = useOrganization();
  const orgPath = useOrgPath();
  if (!selectedOrgBusinessUnit.enableHiringProcess) {
    return <Navigate to={orgPath("/home")} />;
  }
  return <OrgFormsPage />;
}
